/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

import { Base64 } from "js-base64";
import { getAccessToken } from "@/utils/tokenTool";
import { Loading, Notification } from "element-ui";

const baseURL = process.env.VUE_APP_BASE_API;
//格式化时长，单位秒
export function formatDuration(value) {
  let day = parseInt(value / 60 / 60 / 24);
  let hr = parseInt((value / 60 / 60) % 24);
  let min = parseInt((value / 60) % 60);
  let sec = parseInt(value % 60);
  let str = "";
  if (day > 0) {
    str += day + "天";
  }
  if (hr > 0) {
    str += hr + "时";
  }
  if (min > 0) {
    str += min + "分";
  }
  if (sec > 0) {
    str += sec + "秒";
  }
  if (str == "") {
    str = "0秒";
  }
  return str;
}
// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return "-";
  }
  const format = pattern || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    } else if (typeof time === "string") {
      time = time.replace(new RegExp(/-/gm), "/");
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

// 表单重置
export function resetForm(refName) {
  try {
    if (this.$refs[refName]) {
      this.$refs[refName].resetFields();
    }
  } catch (e) {}
}

// 添加日期范围
export function addDateRange(params, dateRange) {
  var search = params;
  search.beginTime = "";
  search.endTime = "";
  if (null != dateRange && "" != dateRange) {
    search.beginTime = dateRange[0];
    search.endTime = dateRange[1];
  }

  return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
  var actions = [];
  Object.keys(datas).map((key) => {
    if (datas[key].key == "" + value) {
      actions.push(datas[key].value);
      return false;
    }
  });
  return actions.join("");
}

// 通用下载方法
export function download(fileName) {
  window.location.href =
    baseURL +
    "/common/filemanager/download?fileName=" +
    encodeURI(fileName) +
    "&delete=" +
    true;
}

export function downloadbyurl(url, filename, callback) {
  var loading = Loading.service({
    lock: true,
    text: "正在下载",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.8)",
  });
  var xhr = new XMLHttpRequest();
  xhr.open("GET", baseURL + url, true);
  xhr.setRequestHeader("Authorization", getAccessToken());
  xhr.responseType = "blob";
  xhr.onload = function (e) {
    loading.close();

    if (this.status == 200) {
      var that = this;
      var blob = this.response;
      var download = function () {
        if (!filename) {
          filename = parseTime(new Date(), "{y}{m}{d}{h}{i}{s}");
          var filenameb64 = that.getResponseHeader("filename-base64");
          if (filenameb64) {
            filename = Base64.decode(filenameb64);
          }
        }
        var a = document.createElement("a");
        var url = URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      };
      if (blob.type == "application/json") {
        var reader = new FileReader();
        reader.readAsText(blob, "utf-8");
        reader.onload = function (e) {
          var json = JSON.parse(reader.result);
          if (json.code && json.msg) {
            Notification.error({
              title: json.msg.replace("服务错误：", ""),
            });
          } else {
            download();
          }
        };
      } else {
        download();
      }
    } else {
      Notification.error({
        title: this.status + " " + this.statusText,
      });
    }
    callback && callback(e);
  };
  xhr.send();
}

// 字符串格式化(%s )
export function sprintf(str) {
  var args = arguments,
    flag = true,
    i = 1;
  str = str.replace(/%s/g, function () {
    var arg = args[i++];
    if (typeof arg === "undefined") {
      flag = false;
      return "";
    }
    return arg;
  });
  return flag ? str : "";
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
  if (!str || str == "undefined" || str == "null") {
    return "";
  }
  return str;
}

function getAllTreeData(data, id, parentId, children) {
  let allData = []
  for (let i = 0; i < data.length; i++) {
    const d = data[i]
    allData.push(d)
    const child = d[children]
    if (child && child.length > 0) {
      for (let j = 0; j < child.length; j++) {
        const c = child[j]
        if (c[parentId] === undefined) {
          c[parentId] = d[id]
        }
      }
      d[children] = []
      const cs = getAllTreeData(child, id, parentId, children)
      allData = allData.concat(cs)
    }
  }
  return allData
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
  id = id || "id";
  parentId = parentId || "parentId";
  children = children || "children";
  rootId = rootId || 0;
  // 旧代码构造树形结构有问题，以下为测试数据
  //data = [{"id":402,"parent_id":401,"ancestors":"0,100,401","name":"电子","no":"1031","sort":0,"leader_nos":"","leader_names":"","phone":"","email":"","homepage":"","address":"","responsibility":"","visits":"\t","type":"3","status":"1","remark":"","ext":"","delete_time":0,"create_by":0,"create_time":0,"update_by":0,"update_time":0},{"id":401,"parent_id":100,"ancestors":"0,100","name":"机电工程学院","no":"103","sort":0,"leader_nos":"","leader_names":"","phone":"","email":"","homepage":"","address":"","responsibility":"","visits":"\r","type":"3","status":"1","remark":"","ext":"","delete_time":0,"create_by":0,"create_time":0,"update_by":0,"update_time":0}]
  //对源数据深度克隆
	const cloneData = JSON.parse(JSON.stringify(data))
	/*//循环所有项
	const treeData = cloneData.filter(father => {
		let branchArr = cloneData.filter(child => {
			//返回每一项的子级数组
			return father[id] === child[parentId]
		});
		branchArr.length > 0 ? father.children = branchArr : '';
		//返回第一层
		return father[parentId] === rootId;
	});
	return treeData != '' ? treeData : data;*/

  // 新的构造树形结构
  const allData = getAllTreeData(cloneData, id, parentId, children)
  const treeMap = {};
  const nodeMap = {};
  for (let i = 0; i < allData.length; i++) {
    const node = allData[i];
    //node[children] = [];
    nodeMap[node[id]] = node;
    treeMap[node[id]] = node;
  }
  
  for (let i = 0; i < allData.length; i++) {
    const node = allData[i];
    if (!treeMap[node[parentId]]) {
      const pnode = {};
      pnode[id] = node[parentId];
      //pnode[children] = [];
      treeMap[node[parentId]] = pnode;
    }
    const parent = treeMap[node[parentId]];
    const cnode = treeMap[node[id]];
    let pchildren = parent[children]
    if (!pchildren) {
      pchildren = []
      parent[children] = pchildren
    }
    let exist = false
    /*for (let j = 0; j < pchildren.length; j++) {
      if (pchildren[j] == cnode) {
        exist = true
        break
      }
    }*/
    if (!exist) {
      pchildren.push(cnode);
    }
    treeMap[node[id]] = cnode;
  }
  let treeList = [];
  for (let key in treeMap) {
    const node = treeMap[key];
    if (!nodeMap[node[id]]) {
      treeList = treeList.concat(node[children]);
    }
  }
  treeList.sort(function (a, b) {
    if (a.sort == b.sort) {
      return a.id - b.id;
    }
    return a.sort - b.sort;
  });
  return treeList;
}
/**
 * 高级查询 逻辑操作符
 * @returns {Array}
 */
export function defaultQlogic() {
  "use strict";
  var ta = [];
  ta.push({ value: "=", label: "等于" });
  ta.push({ value: "!=", label: "不等于" });
  ta.push({ value: ">", label: "大于" });
  ta.push({ value: ">=", label: "大于等于" });
  ta.push({ value: "<", label: "小于" });
  ta.push({ value: "<=", label: "小于等于" });
  ta.push({ value: "LIKE", label: "包含" });
  ta.push({ value: "NOT LIKE", label: "不包含" });
  ta.push({ value: "BETWEEN", label: "在范围内" });
  return ta;
}

/**
 * 日期转为时间戳
 * @param value
 * @returns {number}
 * @constructor
 */
export function DatetounixTimestamp(value) {
  return Math.round(new Date(value).getTime() / 1000);
}
export function unixTimestamptoDate(value, format) {
  var regPos = /^\d{10,}$/; //时间戳
  //处理Unix时间戳
  if (regPos.test(value)) {
    var ttime = value * 1000;
    value = new Date(ttime);
  }
  return this.XEUtils.toDateString(value, format || "yyyy-MM-dd HH:mm:ss");
}
//文件名查找类型
export function lastSubstring(context, char) {
  var index = context.lastIndexOf(char);
  return context.substring(index + 1, context.length);
}
//深拷贝
export function deepCopy(obj) {
  // // 检查是否为基本数据类型或 null
  // if (obj === null || typeof obj !== "object") {
  //   return obj;
  // }

  // // 创建一个空对象或数组来存储复制的属性
  // const copy = Array.isArray(obj) ? [] : {};

  // // 遍历对象的属性
  // for (let key in obj) {
  //   // 递归调用深拷贝函数复制属性值
  //   copy[key] = deepCopy(obj[key]);
  // }

  // return copy;
  //1.判断拷贝的对象是数组还是对象
  const newObj = obj.constructor === Array ? [] : {};
  //2.遍历属性
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      //是否还有数组或对象
      if (obj[key] && typeof obj[key] === "object") {
        //递归
        newObj[key] = deepCopy(obj[key]);
      } else {
        //基本数据类型
        newObj[key] = obj[key];
      }
    }
  }
  return newObj;
}
